export const defaultColors: string[] = ['#ff5621', '#00dab5', '#000933', '#5ab2f9', '#FFC521', '#FF215B', '#DAB500', '#5A62F9'];
